import VehicleBlockShellCap from './VehicleBlockShellCap';

export default VehicleBlockShellCap;
export { VehicleBlockShellCap };
